import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CompetitionWhitelist } from './competition-whitelist'
import * as fromCompetitionWhitelist from './competition-whitelist.reducer'

const state =
  createFeatureSelector<fromCompetitionWhitelist.CompetitionWhitelistState>(
    fromCompetitionWhitelist.FEATURE_NAME
  )

const adapter = fromCompetitionWhitelist.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<CompetitionWhitelist>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: CompetitionWhitelist[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)
const selectCurrentWhiteListObjects = createSelector(selectState, (params) => {
  return params.currentWhiteListSelected
})

const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const competitionWhitelistSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectCurrentWhiteListObjects,
  selectPaginationDetails
}
